<form [formGroup]="entityForm" (submit)="onEntityFormSubmit()">
  <ng-container *ngIf="entityid">
    <h4>Edit "{{ entity[entitylabelkey] }}"</h4>

    <ng-container *ngFor="let element of getFormConfigs()">

      <ng-container *ngIf="element['fieldtype']==='text'">
        <div class="form-group">
          <label>{{element['fieldlabel']}} <span *ngIf="element['language']"
                                                 class="badge bg-light">{{element['language']}}</span></label>
          <input type="text" class="form-control" formControlName="{{element['field']}}"
                 [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"
                 [readonly]="element['readonly']"
                 maxlength="{{element['maxlength']}}"
          />
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='select'">
        <div class="form-group">
          <label>{{element['fieldlabel']}}</label>
          <select class="form-control" formControlName="{{element['field']}}"
                  [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">
            <option *ngFor="let item of element['choices']" value="{{item['id']}}">
              {{item['label']}}
            </option>
          </select>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='checkbox'">
        <div class="form-group">
          <div class="form-check">
            <input id="editCheck" type="checkbox" class="form-check-input" formControlName="{{element['field']}}">
            <label class="form-check-label" for="editCheck"
                   [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">{{element['fieldlabel']}}</label>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='html'">
        <div class="form-group">
          <label>{{element['fieldlabel']}} <span *ngIf="element['language']"
                                                 class="badge bg-light">{{element['language']}}</span></label>
          <editor formControlName="{{element['field']}}" [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"
                  [init]="{
                     base_url: '/tinymce',
                     suffix: '.min',
                     height: 300,
                     menubar: false,
                     statusbar: false,
                     resize: false,
                     branding: false,
                     elementpath: false,
                     plugins: [
                       'advlist autolink lists link image charmap print preview anchor',
                       'searchreplace visualblocks code fullscreen',
                       'insertdatetime media table paste code help'
                     ],
                     toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
                   }"
          ></editor>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

    </ng-container>

    <div class="row no-gutters my-4">
      <div class="col-12 my-1 text-end">
        <button type="button" class="btn btn-secondary me-2" (click)="cancelFormSubmit()">Cancel</button>
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="!entityid">
    <h4>Create</h4>

    <ng-container *ngFor="let element of getFormConfigs()">

      <ng-container *ngIf="element['fieldtype']==='text' && element['field']!=='id'">
        <div class="form-group">
          <label>{{element['fieldlabel']}} <span *ngIf="element['language']"
                                                 class="badge bg-light">{{element['language']}}</span></label>
          <input type="text" class="form-control" formControlName="{{element['field']}}"
                 [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"
                 maxlength="{{element['maxlength']}}"/>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='select'">
        <div class="form-group">
          <label>{{element['fieldlabel']}}</label>
          <select class="form-control" formControlName="{{element['field']}}"
                  [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">
            <option *ngFor="let item of element['choices']" value="{{item['id']}}">
              {{item['label']}}
            </option>
          </select>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='checkbox'">
        <div class="form-group">
          <div class="form-check">
            <input id="check" type="checkbox" class="form-check-input" formControlName="{{element['field']}}">
            <label class="form-check-label" for="check"
                   [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">{{element['fieldlabel']}}</label>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='html'">
        <div class="form-group">
          <label>{{element['fieldlabel']}} <span *ngIf="element['language']"
                                                 class="badge bg-light">{{element['language']}}</span></label>
          <editor formControlName="{{element['field']}}" [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"
                  [init]="{
                     base_url: '/tinymce',
                     suffix: '.min',
                     height: 300,
                     menubar: false,
                     statusbar: false,
                     resize: false,
                     branding: false,
                     elementpath: false,
                     plugins: [
                       'advlist autolink lists link image charmap print preview anchor',
                       'searchreplace visualblocks code fullscreen',
                       'insertdatetime media table paste code help'
                     ],
                     toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
                   }"
          ></editor>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

    </ng-container>

    <div class="row no-gutters my-4">
      <div class="col-12 my-1 text-end">
        <button type="button" class="btn btn-secondary me-2" (click)="cancelFormSubmit()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create</button>
      </div>
    </div>

  </ng-container>

</form>
